import isDefaultMeetingType from './isDefaultMeetingType';

/** Function to check is the default meeting type is deleted
 *  Hide default meeting type from the organizer dashboard when
 *  1) meetingTypeId is the default meeting type ID
 *  2) meeting type is excludedFromService
 */

export default function isDeletedDefaultMeetingType(
    meetingTypeId: string | undefined,
    excludeFromService: boolean
): boolean {
    return isDefaultMeetingType(meetingTypeId) && excludeFromService;
}
